import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function LocationViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Location())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(LocationViewModel, SearchPaging);
LocationViewModel.prototype.PrimaryKey = "LocationId";
LocationViewModel.prototype.RefreshUrl = "Location/GetLocation";
LocationViewModel.prototype.SaveUrl = "Location/SaveLocation";
LocationViewModel.prototype.DeleteUrl = "Location/DeleteLocation";
LocationViewModel.prototype.IsInUseUrl = "Location/IsLocationInUse";
LocationViewModel.prototype.PermissionForward = "LocationMoveForwardSearch";
LocationViewModel.prototype.PermissionBackward = "LocationMoveBackwardSearch";
LocationViewModel.prototype.PermissionSave = "LocationSave";
LocationViewModel.prototype.PermissionRefresh = "LocationRefresh";
LocationViewModel.prototype.PermissionDelete = "LocationDelete";
export default LocationViewModel;